/*eslint-disable*/
import React, { Component } from 'react';
import { Icon } from 'semantic-ui-react';

export default class CustomNoRowsOverlay extends Component {
    render() {
        return (
            <div>
                <Icon name="frown" />  {this.props.noRowsMessageFunc()}
            </div>
        );
    }
}